import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { compose, graphql } from 'react-apollo';
import { getPackagesAvailable } from "../../graphqlDic";
import Packages from '../../components/Scoin/Packages';

export default compose(graphql(getPackagesAvailable, {
    name: 'getPackagesAvailable'
}))(withRouter(
    connect(
        null,
        null
    )(Packages)
)
);


// WEBPACK FOOTER //
// ./src/containers/Scoin/Packages.js